export default class FormValidatorIndicator {
    errorMsgClass = "error-message-ajax";
    errorAddClass = "invalid-feedback d-block";

    /**
     * Indicates whether the input field is filled correctly
     * @param {Node} input - validated input element
     */
    correctIndicator(input) {

        if (this.blockIndicator) return;
        // if (input.nodeName === 'SELECT') return;
        if (input.className === 'select-wrapper' && input.firstChild.nodeName === 'SELECT') {
            input = input.firstChild;

        }

        if (input.type === 'fieldset') {
            if (input.firstChild.tagName === 'LEGEND') {
                input = input.firstChild;
            }
            if (input.lastChild.tagName === 'LEGEND') {
                input = input.lastChild;
            }
        }

        input.style.transition = 'all .4s ease-in-out';
        input.style.borderColor = `${input.correct ? '#198754' : '#e72235'}`;
  /*      if (input.type === 'checkbox') {
            let label = input.parentElement.querySelector(['label']);
            label.style.color = `${input.correct ? '#198754' : '#e72235'}`;
        } else {
            input.style.color = `${input.correct ? '#198754' : '#e72235'}`;
        }*/
        if (input.type !== 'checkbox') {
            input.style.color = `${input.correct ? '#198754' : '#e72235'}`;
        }
        input.style.backgroundColor = `${input.correct ? '#fff' : '#fbdadd'}`;

        let existingErrorEl;

        if (input.type === 'checkbox' || input.type === 'radio' || input.type === 'select-multiple') {
                existingErrorEl = input.parentElement.parentElement.querySelector("." + this.errorMsgClass+":not(.extra-div " + "." + this.errorMsgClass + ")");
            /** For checkbox long */
            if (input.parentElement.parentElement.classList.contains('div-checkbox')) {
                existingErrorEl = input.parentElement.parentElement.parentElement.querySelector("." + this.errorMsgClass + ", ." + this.errorAddClass);

            }
        } else {
            existingErrorEl = input.parentElement.querySelector("." + this.errorMsgClass + ", ." + this.errorAddClass);
        }

        let errorEl = document.createElement('div');
        errorEl.className = `${this.errorMsgClass} ${this.errorAddClass}`;

        if (existingErrorEl) {
            errorEl = existingErrorEl;
        }


        if (input.correct === false ) {


            if (typeof input.frontMessages === 'undefined') {
                input.frontMessages = input.frontMessages || [];
            }


            if (input.type === 'checkbox' || input.type === 'radio' ) {
                input = input.parentElement.parentElement;
                this.addMessageIfNotExists(input.frontMessages, input);
                errorEl.innerText = input.frontMessages;
                /** For checkbox long */
                if(input.classList.contains('div-checkbox')){
                    input.parentElement.appendChild(errorEl);
                }
                else {
                    input.appendChild(errorEl);
                }

            }
            else if (input.type === 'select-one'|| input.type === 'select-multiple' ){

                input = input.parentElement;
                this.addMessageIfNotExists(input.frontMessages, input);
                errorEl.innerText = input.frontMessages;
                input.appendChild(errorEl);
            }
            else {
                this.addMessageIfNotExists(input.frontMessages, input);
                errorEl.innerText = input.frontMessages;
                input.parentElement.appendChild(errorEl);
            }

        } else {

            if (existingErrorEl) {
                existingErrorEl.remove();
            }
        }
    }

    /**
     *  Adds a message to the 'input.frontMessages' array
     *  only if it doesn't already exist in the array.
     */
    addMessageIfNotExists(message, input) {
        if (!input.frontMessages.includes(message)) {
            input.frontMessages.push(message);
        }
    }


    disableFormSubmission() {
        if (this.options.disableFormWhileLoading !== true) {
            return;
        }

        this.form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
    }


    enableFormSubmission() {
        if (this.options.disableFormWhileLoading !== true) {
            return;
        }

        this.form.querySelector('[type="submit"]').removeAttribute('disabled');
    }
}